module.exports = __webpack_public_path__ + "static/img/5.c496f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/5.png
// module id = 6H7N
// module chunks = 35